import { api } from '@/lib/api-client.ts'
import { AxiosResponse } from 'axios'
import { paths } from '@/lib/types/api-types.ts'
import { editUser } from '@/routes/settings/account/actions.ts'
import handleApiErr from '@/lib/helpers/handleApiGerError.ts'
import { useUserStore } from '@/store/user.ts'

export const currStageQuery = (projectStageId: string | number, userId: number) => ({
  queryKey: ['currStageUsersQuery', { projectStageId, userId }],
  queryFn: () => getCurrStage(projectStageId, userId),
})

export type CurrStageData =
  paths['/project_stages/{id}']['get']['responses']['200']['content']['application/ld+json']

export const getCurrStage = async (
  projectStageId: string | number,
  userId: number,
): Promise<CurrStageData | undefined> => {
  const projectStageIri = `/project_stages/${projectStageId}`
  const res: AxiosResponse<CurrStageData> = await api.get(projectStageIri)
  if (res.data.id) {
    // Only persist activeProjectStage when it actually changed. This PATCH
    // previously ran on EVERY stage fetch (i.e. every load, via rootLoader),
    // and the resulting ['user'] cache invalidation + refetch triggered a
    // re-render storm that reset in-progress form state on the settings pages
    // (e.g. a staged avatar file being uploaded). Skipping the redundant write
    // avoids that churn.
    const currentActiveStage = useUserStore.getState().user?.activeProjectStage
    if (currentActiveStage !== String(res.data.id)) {
      editUser(userId, { activeProjectStage: String(res.data.id) }).catch(handleApiErr)
    }
  }
  return res.data
}
